/* src/app/components/controls/sem-dynamic-search-field/sem-dynamic-search-field.component.css */
.wg-search .search-item.multiple-field-search-item {
  width: 100% !important;
  grid-column: span 1 !important;
  display: block !important;
}
.wg-search .sem-dynamic-multiple-field {
  width: 100% !important;
  padding: 0 !important;
  padding-bottom: 0 !important;
}
.wg-search .sem-dynamic-multiple-field .dynamic-multiple-field-containe-first-row,
.wg-search .sem-dynamic-multiple-field .dynamic-multiple-field-containe-second-row {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  width: 100% !important;
}
.wg-search .sem-dynamic-multiple-field .dynamic-multiple-field-container {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  flex: 1 !important;
}
.wg-search .sem-dynamic-multiple-field .multiple-field-row {
  display: block !important;
  flex: 1 !important;
  width: auto !important;
}
.wg-search .sem-dynamic-multiple-field .multiple-field-separator {
  display: block !important;
  flex: 0 0 auto !important;
  width: auto !important;
  color: #94a3b8 !important;
  padding: 0 2px !important;
  padding-right: 2px !important;
}
.wg-search .sem-dynamic-multiple-field .multiple-field-dynamic-text-box {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  padding: 0 !important;
  padding-right: 0 !important;
  vertical-align: initial !important;
}
.wg-search .sem-dynamic-multiple-field .multiple-field-dynamic-text-box input.sem-text-box {
  height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #cbd5e1 !important;
  padding: 0 12px !important;
  font-size: 13px !important;
  font-family: "Inter", sans-serif !important;
  color: #0f172a !important;
  background: white !important;
  background-image: none !important;
  outline: none !important;
  width: 100% !important;
  box-sizing: border-box !important;
  display: block !important;
  max-width: none !important;
}
.wg-search .sem-dynamic-multiple-field p {
  text-transform: none !important;
  font-size: 13px !important;
  color: #64748b !important;
  margin: 4px 0 !important;
}
.wg-search .sem-dynamic-multiple-field-label {
  display: block !important;
  font-family: "Inter", sans-serif !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  color: #64748b !important;
  margin-bottom: 6px !important;
}
.sem-dynamic-field-content.df-checkbox .sem-dynamic-checkbox {
  width: auto !important;
  display: inline-block !important;
  padding-right: 0 !important;
}
.sem-dynamic-field-content.df-checkbox .sem-dynamic-checkbox > .dynamic-checkbox {
  width: 25px !important;
  height: 25px !important;
  position: relative !important;
  top: 0 !important;
  overflow: hidden !important;
}
.sem-dynamic-field-content.df-checkbox .dynamic-checkbox .dynamic-checkbox-image-true,
.sem-dynamic-field-content.df-checkbox .dynamic-checkbox .dynamic-checkbox-image-false {
  width: 14px !important;
  height: 14px !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
/*# sourceMappingURL=sem-dynamic-search-field.component.css.map */
